import { INIT_PUSHER, BIND_PUSHER } from "../actions/actions.type";
import { SET, SET_CHANNEL } from "../mutations/mutations.type";
import { ID_PUSHER, CHANNEL_PUSHER } from "../../common/config";
import Pusher from "pusher-js";

const state = {
  pushers: [],
  channel: ""
};

const getters = {
  pushers(state) {
    return state.pushers;
  }
};

const actions = {
  [INIT_PUSHER](context, params) {
    return new Promise((resolve, reject) => {
      try {
        Pusher.logToConsole = false;

        var pusher = new Pusher(ID_PUSHER, {
          cluster: "mt1"
        });

        context.commit(SET_CHANNEL, pusher.subscribe(CHANNEL_PUSHER));
        context.dispatch(BIND_PUSHER, {
          event: "pusher:subscription_succeeded",
          callback: () => {}
        });
        resolve();
      } catch (error) {
        console.log(error);
        reject();
      }
    });
  },
  [BIND_PUSHER](context, params) {
    return new Promise((resolve, reject) => {
      try {
        state.channel.bind(params.event, params.callback);
        resolve();
      } catch (error) {
        console.log(error);
        reject();
      }
    });
  }
};
const mutations = {
  [SET](state, pushers) {
    state.pushers = pushers.message;
  },
  [SET_CHANNEL](state, channel) {
    state.channel = channel;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
